import { render, staticRenderFns } from "./DynamicMeetings.vue?vue&type=template&id=64ab4e89"
import script from "./DynamicMeetings.vue?vue&type=script&lang=js"
export * from "./DynamicMeetings.vue?vue&type=script&lang=js"
import style0 from "./DynamicMeetings.vue?vue&type=style&index=0&id=64ab4e89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports